import React from 'react';
import { useNavigate } from 'react-router-dom';

const relatedWorksList = [
  {
    path: '/works/canine-crown',
    title: 'Canine Crown',
    subtitle: 'Brand identity & packaging design for premium pet nutrition.',
    img: 'https://ascentbw.com/Images/CanineCrown/CanineCover.webp'
  },
  {
    path: '/works/mgr',
    title: 'MGR University',
    subtitle: 'Editorial design and print production of admissions prospectus.',
    img: 'https://ascentbw.com/Images/MGR/Mgr4.webp'
  },
  {
    path: '/works/windplus',
    title: 'Windplus',
    subtitle: 'Corporate website development for renewable energy platforms.',
    img: 'https://ascentbw.com/Images/Windplus/WindplusCover.webp'
  },
  {
    path: '/works/feston',
    title: 'Feston',
    subtitle: 'Immersive exhibition stall design and spatial branding.',
    img: 'https://ascentbw.com/Images/Feston/cover.webp'
  },
  {
    path: '/works/atss',
    title: 'ATSS Technologies',
    subtitle: 'Complete brand communication and security automation catalogs.',
    img: 'https://ascentbw.com/Images/Atss/cover.webp'
  },
  {
    path: '/works/aulpha',
    title: 'Aulpha',
    subtitle: 'Editorial design and print production of corporate prospectus.',
    img: 'https://ascentbw.com/Images/Aulpha/cover.webp'
  }
];

export default function RelatedWorks({ excludePath }) {
  const navigate = useNavigate();
  const filteredWorks = relatedWorksList.filter(work => work.path !== excludePath);
  // Display only a mix of three works
  const mixedWorks = filteredWorks.slice(0, 3);

  return (
    <section className="project-dark-section related-works-blue-bg">
      <style>{`
        .project-dark-section.related-works-blue-bg {
          background-color: #001233 !important;
        }
        .related-works-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 30px;
        }
        @media (max-width: 991px) {
          .related-works-grid {
            grid-template-columns: repeat(2, 1fr);
          }
        }
        @media (max-width: 767px) {
          .related-works-grid {
            grid-template-columns: 1fr;
          }
        }
      `}</style>

      <div className="dark-section-header">
        <h2>Explore More Works</h2>
        <p>
          Discover how we partner with forward-thinking brands across strategy, design, and digital activation to build impact.
        </p>
      </div>

      <div className="related-works-grid">
        {mixedWorks.map((work, index) => (
          <div 
            key={index} 
            className="dark-card" 
            style={{ cursor: 'pointer' }}
            onClick={() => {
              navigate(work.path);
              window.scrollTo(0, 0);
            }}
          >
            <img src={work.img} alt={work.title} />
            <div className="dark-card-content">
              <h3>{work.title}</h3>
              <p>{work.subtitle}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
